export interface BMUserProfile {
  id: number;
  google_id?: string;
  google_access_token?: string;
  google_access_token_expires_at?: Date;
  google_email: string;
  google_family_name: string;
  google_given_name: string;
  google_image_url: string;
}

export function BMUserProfileFromJSON(json: any): BMUserProfile {
  return {
    id: json["id"],
    google_id: json["google_id"] ?? undefined,
    google_access_token: json["google_access_token"] ?? undefined,
    google_access_token_expires_at: json["google_access_token_expires_at"]
      ? new Date(json["google_access_token_expires_at"])
      : undefined,
    google_email: json["google_email"],
    google_family_name: json["google_family_name"],
    google_given_name: json["google_given_name"],
    google_image_url: json["google_image_url"],
  };
}
